export default __webpack_public_path__ + "static/media/checked.2887e858.svg";